import { useMutation } from '@tanstack/react-query';

import { useServices } from '@/shared/hooks/use-services';
import { queryClient } from '@/shared/lib/query-client';
import type { CartItem } from '@/shared/lib/db/schemas/cart.schema';
import type { CategoryByItemId } from './use-cart-quantity-promotion';

/**
 * Promoção por quantidade (PRAT-184): cria OUTRA linha igual à informada
 * (mesmo item, complementos e observação, quantidade 1) em vez de somar na
 * quantidade, para o desconto aparecer numa linha própria. O AddItemUseCase
 * nunca junta linhas iguais (gera id novo sempre), então não há merge.
 *
 * Usado pelo "+" da linha participante e pelo botão do banner "Adicionar
 * mais 1 de {item}".
 */
export function useDuplicateCartLine(categoryByItemId: CategoryByItemId) {
  const { addItem } = useServices();

  return useMutation({
    mutationFn: (item: CartItem) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id, ...line } = item;
      return addItem.execute({
        ...line,
        quantity: 1,
        total_price: 0, // o caso de uso recalcula (preço + complementos + combo)
        // Linha antiga sem categoria ganha a do cardápio, para a nova já nascer certa.
        category_id: line.category_id || categoryByItemId[line.item_id] || null,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart-items'] });
    },
  });
}
